import React, { useEffect, useRef } from 'react';

export const Turnstile = ({ onVerify, sitekey }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let widgetId = null;

    const renderWidget = () => {
      if (window.turnstile && containerRef.current) {
        containerRef.current.innerHTML = '';
        
        widgetId = window.turnstile.render(containerRef.current, {
          sitekey: sitekey,
          callback: (token) => {
            onVerify(token);
          },
          'error-callback': () => {
            onVerify(null);
          },
          'expired-callback': () => {
            onVerify(null);
          }
        });
      }
    };

    if (window.turnstile) {
      renderWidget();
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) {
          renderWidget();
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }

    return () => {
      if (widgetId !== null && window.turnstile) {
        try {
          window.turnstile.remove(widgetId);
        } catch (e) {
          console.error('Error removing turnstile widget:', e);
        }
      }
    };
  }, [sitekey, onVerify]);

  return <div ref={containerRef} className="cf-turnstile flex justify-center" />;
};

export default Turnstile;
